import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserSettingsT } from "../../models/models";

interface InitialStateI {
  settings?: UserSettingsT;
}

const initialState: InitialStateI = {};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setSettings: (state, action: PayloadAction<UserSettingsT>) => {
      state.settings = action.payload;
    },
    updateSettings(state, action: PayloadAction<Partial<UserSettingsT>>) {
      state.settings = {
        ...(state.settings as UserSettingsT),
        ...action.payload,
      };
    },
  },
});

export const { setSettings, updateSettings } = userSlice.actions;

export default userSlice.reducer;
